import React, { useState, useEffect } from "react";
import "../../pages/typical/typical.css";
import { useNavigate } from 'react-router-dom';
import { Quantity } from "./Quantity";
import TypicalProductImage from './TypicalProductImage'
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { formatProductCode, formatUSD, calculateFinalUnitPrice } from '../../helpers/formatterHelper'
import { loadAllItems } from '../../store/myproject-reducer';
import { renderStars } from "../../helpers/reviewHelper";
export function TypicalProductDetail(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { typicalDetail, handleTypicalQuantityChange, handTypicalProdcutAdded, schoolProducts, onSeeReviewClick, layoutSlug, selectedSchool } = props;
    const [product, setProduct] = useState({});
    const [typicalLayout, setTypicalLayout] = useState({});
    const [copied, setCopied] = useState(false);
    var district = {};
    const districtJson = localStorage.getItem('district') ?? '';
    if (districtJson != '') {
        district = JSON.parse(districtJson);
    }

    useEffect(() => {
        setProduct(typicalDetail?.product);
        setTypicalLayout(typicalDetail);
    }, [typicalDetail]);

    const quantityChange = (event) => {
        const selectedQuantity = parseInt(event.target.value, 10);
        const quantityData = {
            id: typicalLayout.id,
            TypicalLayoutId: typicalLayout.typicalLayoutId,
            quantity: selectedQuantity
        };
        handleTypicalQuantityChange(quantityData);
    };
    const typicalProductAdded = (id, typicalId, isAdded) => {
        const productAdded = {
            id: id,
            TypicalLayoutId: typicalId,
            isAdded: isAdded == true ? false : true
        };
        handTypicalProdcutAdded(productAdded);
    }

    const getProductDetails = (productId, typicalproductid, typicalLayoutId, slug) => {
        if (!schoolProducts.includes(productId)) {
            return;
        }

        var typicalLayoutList = [];
        typicalLayoutList.push(typicalLayout);
        localStorage.setItem('typicalLayoutProductDetail', JSON.stringify(typicalLayoutList));
        dispatch(loadAllItems("typicalProductDetailView"));

        navigate('/products/' + productId + '/' + slug + '?cartid=' + typicalproductid + '&typicalid=' + typicalLayoutId + '&istypical=true');

    }

    const copyProductReviewUrl = (productId, typicalproductid, typicalLayoutId, slug) => {
        const fullUrl = `${window.location.origin}/${layoutSlug}/products/${productId}/${slug}/${typicalproductid}/${typicalLayoutId}/${selectedSchool}/review`;
        navigator.clipboard.writeText(fullUrl)
            .then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            })
            .catch(err => console.error("Failed to copy URL:", err));
    };

    const goToProductReview = () => {
        if (onSeeReviewClick) {
            onSeeReviewClick();
        }

        const dropdownElement = document.querySelector('.cart-grid-select.cart-select-arrow.review');
        if (dropdownElement) {

            dropdownElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

            setTimeout(() => {
                dropdownElement.focus();
                dropdownElement.click();
            }, 700);
        }
    };

    return (
        <div className={`prod-grid-row ${typicalLayout?.isAdded ? 'checked' : ''} row-section`}>
            <div className="typical-products--coll cart-img">

                {/*<div className="prod-grid-image-wrap">*/}
                {/*    <img src="https://placehold.jp/128x134.png" alt="product placeholder" />*/}
                {/*</div>*/}
                {product && product.photo ? (
                    <TypicalProductImage
                        photo={product.photo}
                        photoAlt={product.photoAlt ?? product.details.name}
                    />
                ) : (
                    <div className="prod-grid-image-wrap">
                        <span className="errorImage">Image Coming Soon</span>
                    </div>
                )}

            </div>
            <div className="typical-products--coll typical-products--coll-content">
                <div className="prod-grid-col prod-desc typical-prod-desc">
                    <p className="prod-desc-title">{product && product?.details && product.details?.name}</p>
                    {district?.isReviewVisible && (
                        <span className='product-rating'>
                            {renderStars(product?.averageRating)}
                            &nbsp;
                            <span>({product?.reviewCount})</span>
                        </span>
                    )}
                    <p className="prod-desc-content">{product && product?.details && formatProductCode(product)}</p>
                    {/*<span className="prod-desc-color">*/}
                    {/*    <span className="teal-bak">*/}
                    {/*        Color: <span className="prod-desc-color-label">Teal Blue</span>*/}
                    {/*    </span>*/}
                    {/*</span>*/}

                    <div className="product-detail">
                        {typicalLayout.options &&
                            typicalLayout.options.length > 0 &&
                            typicalLayout.options.filter(x => x.type !== 2).map((option) => (
                            <React.Fragment key={option?.id}>
                                <p className="prod-desc-color">
                                    {option?.title}&nbsp;:&nbsp;
                                    {option.optionItems &&
                                        option.optionItems.map((item) => (
                                            <React.Fragment key={item?.id}>
                                                {option.type === 2 ? item.color?.name : item?.title}
                                            </React.Fragment>
                                        ))}
                                    {/*{idx + 1 === product.options.filter(x => x.type !== 2).length ? '' : ' / '}*/}

                                </p>
                            </React.Fragment>
                        ))}
                    </div>
                    
                    <div className="product-detail product-color-detail">
                        {typicalLayout.options &&
                            typicalLayout.options.length > 0 &&
                            typicalLayout.options.filter(x => x.type === 2).map((option) => (
                            <React.Fragment key={option?.id}>
                                <p className="prod-desc-color">{option?.title}:&nbsp;
                                    {option?.optionItems.map((item) => <span
                                        key={item.color?.id}
                                        className="color-icons color-dots large color-select"
                                        style={
                                            item.color?.colorImage
                                                ? {
                                                    backgroundImage: `url(${item.color?.colorImage?.previewsrc})`,
                                                }
                                                : { backgroundColor: item.color?.hex }
                                        }
                                        htmlFor={item.color?.id}
                                    ></span>)}
                                </p>
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </div>
            <div className="typical-products--coll">
                {/*<Quantity />*/}
                <Quantity
                    typicalId={typicalLayout?.id}
                    currentQuantity={typicalLayout?.quantity}
                    setQuantity={quantityChange}
                />
            </div>
            <div className="typical-products--coll desktop-gallery">
                <div className="prod-grid-col prod-total-price">
                    <div className="prod-grid-price-wrap">
                        <p className="prod-grid-total"> {product?.details && formatUSD(calculateFinalUnitPrice(product))}</p>
                    </div>
                </div>
            </div>

            <div className="typical-products--coll desktop-gallery">
                <div className="prod-grid-col prod-unit-price">
                    <div className="prod-grid-total-wrap">

                        <p className="prod-grid-total">{formatUSD(
                            calculateFinalUnitPrice(product) * typicalLayout.quantity
                        )}</p>
                    </div>

                </div>
            </div>
            <div className="typical-products--coll desktop-gallery">

                <div className="subtotal-cart-item subtotal-buttons-wrap">
                    {district?.isReviewVisible && (
                        <>
                            <button
                                type="button"
                                onClick={() => copyProductReviewUrl(product.id, typicalLayout.id, typicalLayout.typicalLayoutId, product.slug)}
                                className="add-cart-cta typical-add-button"
                                title="Copy URL"
                            >
                                <span className={`material-symbols-rounded ${copied ? 'copied-message' : ''}`}>content_copy</span>
                            </button>
                            {/* {copied && <span className="copied-message">Copied!</span>} */}

                            <button
                                type="button"
                                onClick={goToProductReview}
                                className="add-cart-cta typical-add-button"
                            >
                                See Review
                            </button>
                        </>
                    )}
                    <a href="javascript:;" onClick={() => getProductDetails(product.id, typicalLayout.id, typicalLayout.typicalLayoutId, product.slug)} className="add-cart-cta typical-add-button typical-outline-button">
                        View Details
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <mask id="mask0_1849_8031" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_1849_8031)">
                                <path d="M11.475 19.4C11.325 19.25 11.25 19.0707 11.25 18.862C11.25 18.654 11.3167 18.475 11.45 18.325L16.75 13.05H5.125C4.925 13.05 4.75 12.979 4.6 12.837C4.45 12.6957 4.375 12.5167 4.375 12.3C4.375 12.0833 4.45 11.904 4.6 11.762C4.75 11.6207 4.925 11.55 5.125 11.55H16.75L11.45 6.275C11.3167 6.125 11.25 5.946 11.25 5.738C11.25 5.52933 11.325 5.35 11.475 5.2C11.625 5.06667 11.8 5 12 5C12.2 5 12.375 5.06667 12.525 5.2L18.975 11.675C19.075 11.7583 19.146 11.854 19.188 11.962C19.2293 12.0707 19.25 12.1833 19.25 12.3C19.25 12.4167 19.2293 12.529 19.188 12.637C19.146 12.7457 19.075 12.8417 18.975 12.925L12.525 19.4C12.375 19.5333 12.2 19.6 12 19.6C11.8 19.6 11.625 19.5333 11.475 19.4Z" fill="#1C1B1F"/>
                            </g>
                        </svg>
                    </a>
                </div>
            </div>

            <div className="typical-products--coll">
                <div className="prod-grid-col icon-wrap">
                    <div className="prod-grid-action-wrap" onClick={() => typicalProductAdded(typicalLayout.id, typicalLayout.typicalLayoutId, typicalLayout.isAdded)}>
                        {typicalLayout?.isAdded === true ? (
                            <span className="prod-grid-icon checked">
                                <span className="material-symbols-rounded">check</span>
                            </span>
                        ) : (<span className="prod-grid-icon">
                            <span className="material-symbols-rounded">add</span>
                        </span>)
                        }
                    </div>
                </div>
            </div>
            <div className="cart-total-wrap mobile-gallery typical-cart-total-wrap">
                <div className="cart-datawrap">
                    <div className="cart-grid-total-price-wrap">
                        <div className="cart-grid-inner">
                            <p className="mobile-price-label">Unit Price</p>
                            <p className="cart-grid-total left-unit-price">{product?.details && formatUSD(calculateFinalUnitPrice(product))}</p>
                        </div>
                    </div>
                    <div className="cart-grid-unit-price-wrap">
                        <div className="cart-grid-inner">
                            <p className="mobile-price-label">Total Price</p>
                            <p className="cart-grid-total">{formatUSD(
                                calculateFinalUnitPrice(product) * typicalLayout.quantity
                            )}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


TypicalProductDetail.propTypes = {
    typicalDetail: PropTypes.object.isRequired,
    handleTypicalQuantityChange: PropTypes.func.isRequired,
    handTypicalProdcutAdded: PropTypes.func.isRequired,
    schoolProducts: PropTypes.array,
    onSeeReviewClick: PropTypes.func.isRequired,
    layoutSlug: PropTypes.string,
    selectedSchool: PropTypes.number,
};

export default TypicalProductDetail;